import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

var cards_swipers = [];

// TikTok's iframe is a separate browsing context, so a gesture that starts on
// it is consumed entirely inside TikTok's document and never reaches Swiper -
// on touch this breaks swipe, and on desktop it breaks mouse-drag swipe too.
// This shield sits over the iframe so pointer events bubble to Swiper as
// normal; on a tap/click (no meaningful movement) it briefly disables itself
// so the browser's own synthetic click after pointerup lands on the iframe
// instead, keeping tap/click-to-play working for both touch and mouse.
function attachTouchShields(root)
{
    root.querySelectorAll('.tik-tok_card_touch-shield').forEach((shield) => {
        if (shield.dataset.shieldBound) return;
        shield.dataset.shieldBound = 'true';

        let startX = 0;
        let startY = 0;
        let moved = false;
        let dragging = false;

        shield.addEventListener('pointerdown', (e) => {
            dragging = true;
            moved = false;
            startX = e.clientX;
            startY = e.clientY;
        });

        shield.addEventListener('pointermove', (e) => {
            if (!dragging) return;

            if (Math.abs(e.clientX - startX) > 10 || Math.abs(e.clientY - startY) > 10) {
                moved = true;
            }
        });

        const endDrag = () => {
            if (!dragging) return;
            dragging = false;

            if (moved) return;

            shield.style.pointerEvents = 'none';
            setTimeout(() => {
                shield.style.pointerEvents = '';
            }, 350);
        };

        shield.addEventListener('pointerup', endDrag);
        shield.addEventListener('pointercancel', endDrag);
    });
}

function initialiseSwipers()
{
    cards_swipers.forEach(cards_swiper =>
    {
        if (cards_swiper instanceof Swiper)
        {
            cards_swiper.destroy();
        }
    });

    document.querySelectorAll('section.tik-tok .tik-tok_cards').forEach((cards) => {
        const parent_section = cards.closest("section");
        const swiperEl = cards.querySelector(".swiper");

        if (!swiperEl) return;

        attachTouchShields(cards);

        let autoplay = false;
        if (parent_section.classList.contains("autoplay")) {
            autoplay = { delay: 1600 };
        }

        if (parent_section.classList.contains("hide_pagination_dots")) {
            cards.querySelector(".swiper-pagination")?.remove();
        }
        
        const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
        const loop = slideCount > 3;

        if (!loop || parent_section.classList.contains("hide_navigation_arrows")) {
            cards.querySelector(".swiper-button-prev")?.remove();
            cards.querySelector(".swiper-button-next")?.remove();
        }

        const swiper_options = {
            modules: [Navigation, Pagination, Autoplay],
            direction: 'horizontal',
            loop: loop,
            autoplay: autoplay,
            speed: 700,
            spaceBetween: 15,
            // slidesOffsetBefore: 50,
            // slidesOffsetAfter: 50,
            slidesPerView: 'auto',
            centeredSlides: false,
            loopedSlides: 6,
            navigation: {
                nextEl: parent_section.querySelector(".swiper-button-next"),
                prevEl: parent_section.querySelector(".swiper-button-prev"),
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.25,
                    spaceBetween: 14
                },
                560: {
                    slidesPerView: 2.5,
                },
                768: {
                    slidesPerView: 3.25,
                    spaceBetween: 15
                },
                1024: {
                    slidesPerView: 3.5,
                    spaceBetween: 16
                },
            },
        };

        cards_swipers.push(new Swiper(swiperEl, swiper_options));
    });
}

document.addEventListener("DOMContentLoaded", () => {
    initialiseSwipers();
});
